export default __webpack_public_path__ + "static/media/which.5ff0417c.png";